"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactComponent = SvgComponent;
exports.default = void 0;

var _pragma = require("../../pragma");

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgComponent(props) {
  return (0, _pragma.createFelaElement)("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), (0, _pragma.createFelaElement)("defs", null), (0, _pragma.createFelaElement)("clipPath", {
    id: "prefix__a"
  }, (0, _pragma.createFelaElement)("path", {
    d: "M0 0h24v24H0z"
  })), (0, _pragma.createFelaElement)("g", {
    clipPath: "url(#prefix__a)"
  }, (0, _pragma.createFelaElement)("path", {
    fill: "currentColor",
    d: "M17.14 14.48c-.217 2.751-2.288 4.113-4.876 4.113-3.624 0-5.694-2.888-5.694-6.648 0-3.623 1.907-6.62 5.694-6.62 2.588 0 4.55 1.362 4.768 3.46h3.624C20.41 6.633 19.538 4.971 18.04 3.8c-1.498-1.199-3.406-1.798-5.694-1.798-6.13-.082-9.4 4.768-9.345 10.026C2.946 17.422 6.434 22.081 12.21 22c4.522 0 8.282-2.616 8.554-7.52z"
  })));
}

var _default = 'src/asset/icon/commodities.icon.svg';
exports.default = _default;
//# sourceMappingURL=commodities.icon.js.map